/** 监控坐标点位 */
export const monitorPointList = [
  {
    bid: 1,
    projectAbbr: '两江',
    siteName: '福州鼓楼西河园',
    siteAddressCode: '350102908001900083',
    longitude: 119.2552727,
    latitude: 26.0765742,
    ipAddress: '112.51.1.72',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 2,
    projectAbbr: '两江',
    siteName: '福州台江望龙台公园移动网',
    siteAddressCode: '350103500000000006',
    longitude: 119.273305,
    latitude: 26.060285,
    ipAddress: '112.111.46.96',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 3,
    projectAbbr: '两江',
    siteName: '台江江滨东大道基站1',
    siteAddressCode: '350103500000000096',
    longitude: 119.347436,
    latitude: 26.050304,
    ipAddress: '112.51.0.178',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 4,
    projectAbbr: '两江',
    siteName: '福州台江闽江公园闽风园移动网',
    siteAddressCode: '350103908000000164',
    longitude: 119.28993,
    latitude: 26.051283,
    ipAddress: '112.111.46.95',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 5,
    projectAbbr: '两江',
    siteName: '福州仓山仓前中路',
    siteAddressCode: '350104908000000812',
    longitude: 119.305866,
    latitude: 26.047838,
    ipAddress: '112.5.90.95',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 6,
    projectAbbr: '两江',
    siteName: '福州台江世茂外滩铁塔',
    siteAddressCode: '350103908000000087',
    longitude: 119.3200234131,
    latitude: 26.0559387644,
    ipAddress: '112.5.90.99',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 7,
    projectAbbr: '两江',
    siteName: '闽侯南屿海西园乌龙江大道新建7',
    siteAddressCode: '350121500000001107',
    longitude: 119.21988,
    latitude: 26.02973,
    ipAddress: '112.5.155.239',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 8,
    projectAbbr: '两江',
    siteName: '福州仓山西三环中天金海岸',
    siteAddressCode: '350104908000000717',
    longitude: 119.232551,
    latitude: 26.041874,
    ipAddress: '112.51.24.23',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 9,
    projectAbbr: '两江',
    siteName: '马尾海王制药',
    siteAddressCode: '350105908000000203',
    longitude: 119.374269,
    latitude: 26.032393,
    ipAddress: '112.51.15.80',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 10,
    projectAbbr: '两江',
    siteName: '福州马尾林浦水闸灯杆(移动网)',
    siteAddressCode: '350105908000000370',
    longitude: 119.38323,
    latitude: 26.02367,
    ipAddress: '112.51.15.79',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 11,
    projectAbbr: '两江',
    siteName: '仓山南江滨大道5号灯杆',
    siteAddressCode: '350104500000000328',
    longitude: 119.400274,
    latitude: 26.009603,
    ipAddress: '112.51.24.12',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 12,
    projectAbbr: '两江',
    siteName: '福州马尾快安名城港湾灯杆(移动网)',
    siteAddressCode: '350105908000000244',
    longitude: 119.4178397,
    latitude: 26.01307689,
    ipAddress: '112.51.15.82',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 13,
    projectAbbr: '两江',
    siteName: '福州马尾快安玖玖丰田灯杆(移动网)',
    siteAddressCode: '350105908000000279',
    longitude: 119.42825,
    latitude: 26.00589,
    ipAddress: '112.51.15.81',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 14,
    projectAbbr: '两江',
    siteName: '仓山南江滨大道13号灯杆',
    siteAddressCode: '350104500000000336',
    longitude: 119.42209,
    latitude: 25.97762,
    ipAddress: '112.51.27.10',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 15,
    projectAbbr: '两江',
    siteName: '福州仓山城门峡北村南',
    siteAddressCode: '350104908001900936',
    longitude: 119.39207,
    latitude: 25.96637,
    ipAddress: '112.5.90.94',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 16,
    projectAbbr: '两江',
    siteName: '福州闽侯祥谦龙祥岛',
    siteAddressCode: '350121908000000821',
    longitude: 119.34209,
    latitude: 25.96536,
    ipAddress: '211.143.198.109',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 17,
    projectAbbr: '两江',
    siteName: '闽侯县祥谦江中_CWZ1',
    siteAddressCode: '350121908000000133',
    longitude: 119.33151,
    latitude: 25.96748,
    ipAddress: '211.143.198.110',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 18,
    projectAbbr: '两江',
    siteName: '福州闽侯祥谦禄家',
    siteAddressCode: '350121908001900026',
    longitude: 119.3107857,
    latitude: 25.97663965,
    ipAddress: '211.143.198.105',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 19,
    projectAbbr: '两江',
    siteName: '仓山区南三环六凤尾电信铁塔基站',
    siteAddressCode: '350104700000179903',
    longitude: 119.293344,
    latitude: 25.98789989,
    ipAddress: '112.49.121.103',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 20,
    projectAbbr: '两江',
    siteName: '福州闽侯南屿六十分村移动网',
    siteAddressCode: '350121908000000706',
    longitude: 119.2551793,
    latitude: 25.98352048,
    ipAddress: '211.143.198.107',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 21,
    projectAbbr: '两江',
    siteName: '福州闽侯南屿冠洲',
    siteAddressCode: '350121908000000862',
    longitude: 119.2500202,
    latitude: 25.9933862,
    ipAddress: '211.143.198.108',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 22,
    projectAbbr: '两江',
    siteName: '福州仓山西三环华润橡树湾',
    siteAddressCode: '350104908000000830',
    longitude: 119.253833,
    latitude: 26.015389,
    ipAddress: '112.5.90.98',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 23,
    projectAbbr: '两江',
    siteName: '仓山金山寺搬迁',
    siteAddressCode: '350104908000000826',
    longitude: 119.22727,
    latitude: 26.07404,
    ipAddress: '112.5.90.92',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 24,
    projectAbbr: '两江',
    siteName: '福州闽侯厚美江边移动网',
    siteAddressCode: '350121908001900789',
    longitude: 119.20798,
    latitude: 26.08448,
    ipAddress: '211.143.198.98',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 25,
    projectAbbr: '两江',
    siteName: '福州仓山西三环建新科贡',
    siteAddressCode: '350104908001900696',
    longitude: 119.22298,
    latitude: 26.09595,
    ipAddress: '112.5.90.93',
    openPorts: '37777                   \n18320',
    manufacturer: '大华',
    deviceModel: 'DH-PTZ-85448-HNF-WA-EFL',
  },
  {
    bid: 26,
    projectAbbr: '闽江下游',
    siteName: '福州鼓楼西河园',
    siteAddressCode: '350102908001900083',
    longitude: 119.255471,
    latitude: 26.076572,
    ipAddress: '112.51.1.73',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 27,
    projectAbbr: '闽江下游',
    siteName: '福州仓山金山大桥',
    siteAddressCode: '350104908001900716',
    longitude: 119.265334,
    latitude: 26.059986,
    ipAddress: '112.5.90.115',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 28,
    projectAbbr: '闽江下游',
    siteName: '福州台江闽江公园闽风园移动网',
    siteAddressCode: '350103908000000164',
    longitude: 119.28993,
    latitude: 26.051283,
    ipAddress: '112.111.46.94',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 29,
    projectAbbr: '闽江下游',
    siteName: '福州仓山仓前中路',
    siteAddressCode: '350104908000000812',
    longitude: 119.305866,
    latitude: 26.047838,
    ipAddress: '112.5.90.148',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 30,
    projectAbbr: '闽江下游',
    siteName: '福州台江世茂外滩铁塔',
    siteAddressCode: '350103908000000087',
    longitude: 119.3200234131,
    latitude: 26.0559387644,
    ipAddress: '112.51.0.175',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 31,
    projectAbbr: '闽江下游',
    siteName: '福州仓山南江滨大道DCS',
    siteAddressCode: '350104908001900839',
    longitude: 119.333132,
    latitude: 26.049673,
    ipAddress: '112.51.24.95',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 32,
    projectAbbr: '闽江下游',
    siteName: '台江江滨东大道基站1',
    siteAddressCode: '350103500000000096',
    longitude: 119.347436,
    latitude: 26.050304,
    ipAddress: '112.51.0.176',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 33,
    projectAbbr: '闽江下游',
    siteName: '仓山新省科技馆背后栈道',
    siteAddressCode: '350104500000001844',
    longitude: 119.3592,
    latitude: 26.03564,
    ipAddress: '112.51.24.24',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 34,
    projectAbbr: '闽江下游',
    siteName: '仓山南江滨大道2号灯杆',
    siteAddressCode: '350104500000000323',
    longitude: 119.380406,
    latitude: 26.015838,
    ipAddress: '112.51.24.11',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 35,
    projectAbbr: '闽江下游',
    siteName: '仓山海峡文化艺术中心影视中心右方',
    siteAddressCode: '350104500000002230',
    longitude: 119.415434,
    latitude: 25.998411,
    ipAddress: '112.51.24.13',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 36,
    projectAbbr: '闽江下游',
    siteName: '福州仓山城门峡北村南',
    siteAddressCode: '350104908001900936',
    longitude: 119.39207,
    latitude: 25.966368,
    ipAddress: '112.5.90.100',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 37,
    projectAbbr: '闽江下游',
    siteName: '仓山螺洲大桥北',
    siteAddressCode: '350104010000000161',
    longitude: 119.340653,
    latitude: 25.985019,
    ipAddress: '112.49.121.145',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 38,
    projectAbbr: '闽江下游',
    siteName: '福州闽侯祥谦禄家',
    siteAddressCode: '350121908001900026',
    longitude: 119.311083,
    latitude: 25.976833,
    ipAddress: '211.143.198.106',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 39,
    projectAbbr: '闽江下游',
    siteName: '仓山区南三环六凤尾电信铁塔基站',
    siteAddressCode: '350104700000179903',
    longitude: 119.293903,
    latitude: 25.98773,
    ipAddress: '112.49.121.104',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 40,
    projectAbbr: '闽江下游',
    siteName: '福州仓山湾边特大桥',
    siteAddressCode: '350104908001900791',
    longitude: 119.266911,
    latitude: 26.001041,
    ipAddress: '112.5.90.101',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 41,
    projectAbbr: '闽江下游',
    siteName: '福州仓山西三环华润橡树湾',
    siteAddressCode: '350104908000000830',
    longitude: 119.253833,
    latitude: 26.015389,
    ipAddress: '112.5.90.147',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 42,
    projectAbbr: '闽江下游',
    siteName: '福州仓山乌龙江湿地公园北',
    siteAddressCode: '350104908001900701',
    longitude: 119.229999,
    latitude: 26.050885,
    ipAddress: '112.5.90.102',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 43,
    projectAbbr: '闽江下游',
    siteName: '福州仓山金山洪塘水闸DCS',
    siteAddressCode: '350104908001900699',
    longitude: 119.228395,
    latitude: 26.068443,
    ipAddress: '112.5.90.112',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 44,
    projectAbbr: '闽江下游',
    siteName: '仓山金山寺搬迁',
    siteAddressCode: '350104908000000826',
    longitude: 119.227271,
    latitude: 26.074039,
    ipAddress: '112.5.90.113',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 45,
    projectAbbr: '闽江下游',
    siteName: '福州仓山西三环建新科贡',
    siteAddressCode: '350104908001900696',
    longitude: 119.22298,
    latitude: 26.09595,
    ipAddress: '112.5.90.114',
    openPorts: '81                   8000',
    manufacturer: '海康',
    deviceModel: '(i)DS-2DF7C4ABCD-XYZ/VWS',
  },
  {
    bid: 46,
    projectAbbr: '水利试点',
    siteName: '福州仓山仓前中路',
    siteAddressCode: '350104908000000812',
    longitude: 119.305866,
    latitude: 26.047838,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 47,
    projectAbbr: '水利试点',
    siteName: '闽清溪口大桥灯杆搬迁',
    siteAddressCode: '350124500000000218',
    longitude: 118.878092,
    latitude: 26.213706,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 48,
    projectAbbr: '水利试点',
    siteName: '闽侯县鸿尾埕头村高速',
    siteAddressCode: '35012101000187',
    longitude: 118.953624,
    latitude: 26.210119,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 49,
    projectAbbr: '水利试点',
    siteName: '福州闽侯鸿尾源口(移动网)',
    siteAddressCode: '350121908000000688',
    longitude: 119.001121,
    latitude: 26.198226,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 50,
    projectAbbr: '水利试点',
    siteName: '闽侯侯官水闸',
    siteAddressCode: '350121700000179669',
    longitude: 119.188574,
    latitude: 26.104863,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 51,
    projectAbbr: '水利试点',
    siteName: '福州闽侯南屿六十分村移动网',
    siteAddressCode: '350121908000000706',
    longitude: 119.255428,
    latitude: 25.983541,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 52,
    projectAbbr: '水利试点',
    siteName: '仓山区南三环六凤尾电信铁塔基站',
    siteAddressCode: '350104700000179903',
    longitude: 119.293903,
    latitude: 25.98773,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 53,
    projectAbbr: '水利试点',
    siteName: '福州闽侯祥谦禄家',
    siteAddressCode: '350121908001900026',
    longitude: 119.311083,
    latitude: 25.976833,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 54,
    projectAbbr: '水利试点',
    siteName: '福州闽侯祥谦江中村(移动网)',
    siteAddressCode: '350121908000000741',
    longitude: 119.337128,
    latitude: 25.973012,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 55,
    projectAbbr: '水利试点',
    siteName: '仓山乌龙江特大桥（搬迁）',
    siteAddressCode: '350104500000000324',
    longitude: 119.409883,
    latitude: 25.968499,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 56,
    projectAbbr: '水利试点',
    siteName: '仓山区南江滨西大道闽江大桥西侧电信美化灯杆',
    siteAddressCode: '350104700000022629',
    longitude: 119.315638,
    latitude: 26.052251,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
  {
    bid: 57,
    projectAbbr: '水利试点',
    siteName: '福州仓山南江滨大道DCS',
    siteAddressCode: '350104908001900839',
    longitude: 119.333132,
    latitude: 26.049673,
    ipAddress: '未获取',
    openPorts: null,
    manufacturer: null,
    deviceModel: null,
  },
]

/** 航标点位 */
export const marckPointList = [
  {
    id: 8,
    location: '南7#',
    name: '过河标右',
    longitude: 119.3614189426575,
    latitude: 25.97136827905469,
  },
  {
    id: 13,
    location: '南13#',
    name: '过河标右',
    longitude: 119.2772619526062,
    latitude: 25.9815821309834,
  },
  {
    id: 15,
    location: '南15#',
    name: '浮标左',
    longitude: 119.2585508625183,
    latitude: 26.00527140100293,
  },
  {
    id: 18,
    location: '南18#',
    name: '',
    longitude: 119.2188840324934,
    latitude: 26.04091403858234,
  },
  {
    id: 35,
    location: '15#',
    name: '过河标左',
    longitude: 119.232415,
    latitude: 26.108869,
  },
  {
    id: 68,
    location: '闽干27#',
    name: '侧面标-左',
    longitude: 118.952071,
    latitude: 26.215771,
  },
  {
    id: 70,
    location: '闽干29#',
    name: '浮标左',
    longitude: 118.930055,
    latitude: 26.226328,
  },
  {
    id: 74,
    location: '闽干33#',
    name: '侧面标-左',
    longitude: 118.895766,
    latitude: 26.204493,
  },
  {
    id: 76,
    location: '闽干35#',
    name: '',
    longitude: 118.8733273382471,
    latitude: 26.236223226685,
  },
  {
    id: 79,
    location: '闽干38#',
    name: '',
    longitude: 118.871347,
    latitude: 26.247585,
  },
  {
    id: 57,
    location: '闽干16#',
    name: '浮标左',
    longitude: 119.049135,
    latitude: 26.211791,
  },
  {
    id: 39,
    location: '17#',
    name: '--',
    longitude: 119.2167766478848,
    latitude: 26.10197071627373,
  },
  {
    id: 1,
    location: '南1#',
    name: '右标',
    longitude: 119.4096291200983,
    latitude: 25.96282400796699,
  },
  {
    id: 2,
    location: '南2#',
    name: '左标',
    longitude: 119.410296300099,
    latitude: 25.96117784783992,
  },
  {
    id: 3,
    location: '南3#',
    name: '右标',
    longitude: 119.4029227559955,
    latitude: 25.96308448576984,
  },
  {
    id: 4,
    location: '南4#',
    name: '左标',
    longitude: 119.3995398853763,
    latitude: 25.96164747362419,
  },
  {
    id: 5,
    location: '南5#',
    name: '浮标左',
    longitude: 119.3875114719543,
    latitude: 25.96257063348584,
  },
  {
    id: 6,
    location: '南6#',
    name: '浮标左',
    longitude: 119.3730919162903,
    latitude: 25.9691366811543,
  },
  {
    id: 7,
    location: '南6-1#',
    name: '浮泛滥标',
    longitude: 119.3765466015013,
    latitude: 25.9682569165974,
  },

  {
    id: 9,
    location: '南8#',
    name: '过河标左',
    longitude: 119.3512050907287,
    latitude: 25.97947927911572,
  },
  {
    id: 10,
    location: '南10#',
    name: '浮标右',
    longitude: 119.3193615,
    latitude: 25.97947910075525,
  },
  {
    id: 11,
    location: '南11#',
    name: '沿岸标右',
    longitude: 119.3049768217073,
    latitude: 25.97937813105375,
  },
  {
    id: 12,
    location: '南12#',
    name: '浮标右',
    longitude: 119.2927973072204,
    latitude: 25.97771975000195,
  },

  {
    id: 14,
    location: '南14#',
    name: '浮标左',
    longitude: 119.2699663440857,
    latitude: 25.99248262841992,
  },

  {
    id: 16,
    location: '南16#',
    name: '浮标右',
    longitude: 119.2414705555115,
    latitude: 26.00990625818066,
  },
  {
    id: 17,
    location: '南17#',
    name: '浮标左',
    longitude: 119.23760817453,
    latitude: 26.01797434289746,
  },

  {
    id: 19,
    location: '南19#',
    name: '浮标左',
    longitude: 119.221772,
    latitude: 26.042264,
  },
  {
    id: 20,
    location: '南20#',
    name: '浮标左',
    longitude: 119.222545,
    latitude: 26.060031,
  },
  {
    id: 21,
    location: '南21#',
    name: '浮标左',
    longitude: 119.224862,
    latitude: 26.065353,
  },
  {
    id: 22,
    location: '南24#',
    name: '浮标左',
    longitude: 119.223489,
    latitude: 26.083721,
  },
  {
    id: 23,
    location: '南25#',
    name: '浮标右',
    longitude: 119.217223,
    latitude: 26.096509,
  },
  {
    id: 24,
    location: '南26#',
    name: '',
    longitude: 119.21310537914,
    latitude: 26.1039709485623,
  },
  {
    id: 25,
    location: '2#',
    name: '浮标右',
    longitude: 119.297003,
    latitude: 26.047243,
  },
  {
    id: 26,
    location: '3#',
    name: '浮标右',
    longitude: 119.292797,
    latitude: 26.0475,
  },
  {
    id: 27,
    location: '4#',
    name: '浮标左',
    longitude: 119.289278,
    latitude: 26.051105,
  },
  {
    id: 28,
    location: '6#',
    name: '过河标右',
    longitude: 119.274258,
    latitude: 26.05574,
  },
  {
    id: 29,
    location: '7#',
    name: '过河标左',
    longitude: 119.272713,
    latitude: 26.058916,
  },
  {
    id: 30,
    location: '9#',
    name: '沿岸标左',
    longitude: 119.26516,
    latitude: 26.065095,
  },
  {
    id: 31,
    location: '10#',
    name: '沿岸标左',
    longitude: 119.258293,
    latitude: 26.072992,
  },
  {
    id: 32,
    location: '11#',
    name: '浮标右',
    longitude: 119.251084,
    latitude: 26.075223,
  },
  {
    id: 33,
    location: '13#',
    name: '过河标右',
    longitude: 119.239368,
    latitude: 26.097625,
  },
  {
    id: 34,
    location: '14#',
    name: '过河标左',
    longitude: 119.236364,
    latitude: 26.104063,
  },

  {
    id: 36,
    location: '45672',
    name: '浮标右',
    longitude: 119.2423932354125,
    latitude: 26.09262558419995,
  },
  {
    id: 38,
    location: '16#',
    name: '过河标右',
    longitude: 119.225806,
    latitude: 26.105607,
  },

  {
    id: 40,
    location: '17-1#',
    name: '',
    longitude: 119.2191331188353,
    latitude: 26.09974953134349,
  },
  {
    id: 41,
    location: '闽干1#',
    name: '浮标右',
    longitude: 119.197396,
    latitude: 26.106809,
  },
  {
    id: 42,
    location: '闽干2#',
    name: '浮标右',
    longitude: 119.181947,
    latitude: 26.1087097,
  },
  {
    id: 43,
    location: '闽干3#',
    name: '浮标右',
    longitude: 119.174051,
    latitude: 26.106637,
  },
  {
    id: 44,
    location: '闽干4#',
    name: '浮标左',
    longitude: 119.166326,
    latitude: 26.109856,
  },
  {
    id: 45,
    location: '闽干5#',
    name: '5#',
    longitude: 119.1508008544319,
    latitude: 26.12721065904688,
  },
  {
    id: 46,
    location: '5-1#',
    name: '5#',
    longitude: 119.1478319981644,
    latitude: 26.12950214127915,
  },
  {
    id: 47,
    location: '闽干6#',
    name: '浮标左',
    longitude: 119.143055,
    latitude: 26.134608,
  },
  {
    id: 48,
    location: '闽干7#',
    name: '1s',
    longitude: 119.1388439632219,
    latitude: 26.138362586232,
  },
  {
    id: 49,
    location: '闽干8#',
    name: '侧面标-左',
    longitude: 119.126275,
    latitude: 26.137912,
  },
  {
    id: 50,
    location: '闽干9#',
    name: '沿岸标右',
    longitude: 119.101942,
    latitude: 26.150985,
  },
  {
    id: 51,
    location: '闽干10#',
    name: '浮标右',
    longitude: 119.091664,
    latitude: 26.159649,
  },
  {
    id: 52,
    location: '闽干11#',
    name: '沿岸标右',
    longitude: 119.076987,
    latitude: 26.17321,
  },
  {
    id: 53,
    location: '闽干12#',
    name: '浮标右',
    longitude: 119.073382,
    latitude: 26.17999,
  },
  {
    id: 54,
    location: '闽干13#',
    name: '浮标左',
    longitude: 119.076901,
    latitude: 26.186428,
  },
  {
    id: 55,
    location: '闽干14#',
    name: '浮标右',
    longitude: 119.063579,
    latitude: 26.201963,
  },
  {
    id: 56,
    location: '闽干15#',
    name: '过河标右',
    longitude: 119.049135,
    latitude: 26.209216,
  },

  {
    id: 58,
    location: '闽干17#',
    name: '浮标左',
    longitude: 119.037955,
    latitude: 26.216705,
  },
  {
    id: 59,
    location: '闽干18#',
    name: '沿岸标左',
    longitude: 119.022077,
    latitude: 26.215396,
  },
  {
    id: 60,
    location: '闽干19#',
    name: '过河标左',
    longitude: 119.011291,
    latitude: 26.214719,
  },
  {
    id: 61,
    location: '闽干20#',
    name: '过河标右',
    longitude: 119.007228,
    latitude: 26.207285,
  },
  {
    id: 62,
    location: '闽干21#',
    name: '沿岸标右',
    longitude: 118.994107,
    latitude: 26.194758,
  },
  {
    id: 63,
    location: '闽干22#',
    name: '沿岸标右',
    longitude: 118.983975,
    latitude: 26.191963,
  },
  {
    id: 64,
    location: '闽干23#',
    name: '过河标右',
    longitude: 118.974301,
    latitude: 26.192897,
  },
  {
    id: 65,
    location: '闽干24#',
    name: '过河标左',
    longitude: 118.969537,
    latitude: 26.203412,
  },
  {
    id: 66,
    location: '闽干25#',
    name: '浮标左',
    longitude: 118.968465,
    latitude: 26.205815,
  },
  {
    id: 67,
    location: '闽干26#',
    name: '浮标左',
    longitude: 118.964216,
    latitude: 26.210535,
  },

  {
    id: 69,
    location: '闽干28#',
    name: '浮标左',
    longitude: 118.94396,
    latitude: 26.22311,
  },

  {
    id: 71,
    location: '闽干30#',
    name: '',
    longitude: 118.9116766180794,
    latitude: 26.22569136764221,
  },
  {
    id: 72,
    location: '闽干31#',
    name: '浮标左',
    longitude: 118.906538,
    latitude: 26.218163,
  },
  {
    id: 73,
    location: '闽干32#',
    name: '过河标右',
    longitude: 118.901173,
    latitude: 26.204406,
  },

  {
    id: 75,
    location: '闽干34#',
    name: '浮标右',
    longitude: 118.878342,
    latitude: 26.2163,
  },

  {
    id: 77,
    location: '闽干36#',
    name: '',
    longitude: 118.8734270630496,
    latitude: 26.24507037197807,
  },
  {
    id: 78,
    location: '闽干37#',
    name: '',
    longitude: 118.8735480364358,
    latitude: 26.25047084450323,
  },
  {
    id: 80,
    location: '安仁溪',
    name: '过河标右',
    longitude: 118.857829,
    latitude: 26.297796,
  },
  {
    id: 81,
    location: '--',
    name: '沿岸标右',
    longitude: 118.845581,
    latitude: 26.293633,
  },
  {
    id: 82,
    location: '象尾口',
    name: '过河标左',
    longitude: 118.83995,
    latitude: 26.29556,
  },
]

/** 航标信息类型  */
export type IMarckPointInfoType = (typeof marckPointList)[number] & {
  dept: string
  time: string
  power: string
  status: string
  typename: string
}

/** 公告列表 */
export const noticePointList = [
  {
    hdtgName: '福州市水路运输事业发展中心关于闽清大桥附近航段淤浅的通告',
    hdtgNo: '榕水运(2025)01号',
    dateEvent: 1737013740000,
    sshd: '闽清大桥附近航段',
    dateStart: 1736985600000,
    dateEnd: 1743436800000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2025</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">01</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">16</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">15</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：04</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，闽清大桥附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道闽清大桥附近航段存在浅点。设计水深-2.7（m），最浅点水深-1.7（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry:
      '119.886671,32.222685#119.886326,32.220333#119.889003,32.220394#119.889003,32.222827#119.886671,32.222685',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [118.88, 26.21544],
        [118.87968, 26.21441],
        [118.88012, 26.21384],
        [118.88126, 26.21386],
        [118.88077, 26.2151],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于北港魁浦大桥附近航段淤浅的通告',
    hdtgNo: '榕水运(2025)02号',
    dateEvent: 1737013740000,
    sshd: '北港魁浦大桥附近航段',
    dateStart: 1736985600000,
    dateEnd: 1743436800000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2025</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">01</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">16</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">15</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：04</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，北港魁浦大桥附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道北港魁浦大桥附近航段存在浅点。设计水深-3.7（m），最浅点水深-2.3（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry: '111.71368,30.399322',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.374907, 26.027883],
        [119.375746, 26.025669],
        [119.377158, 26.025345],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于南港百七股洲附近航段淤浅的通告',
    hdtgNo: '榕水运(2025)03号',
    dateEvent: 1737013740000,
    sshd: '南港百七股洲附近航段',
    dateStart: 1736985600000,
    dateEnd: 1743436800000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2025</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">01</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">16</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">15</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：04</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，南港百七股洲附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道南港百七股洲附近航段存在浅点。设计水深-2.5（m），最浅点水深-1.4（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry:
      '105.012598,28.837663#105.005168,28.823511#105.016475,28.819375#105.022096,28.831409#105.012598,28.837663',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.220896, 26.043121],
        [119.221386, 26.038735],
        [119.225491, 26.032616],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于北港淮安头附近航段淤浅的通告',
    hdtgNo: '榕水运(2025)04号',
    dateEvent: 1737013740000,
    sshd: '北港淮安头附近航段',
    dateStart: 1736985600000,
    dateEnd: 1736985600000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2025</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">01</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">16</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">15</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：04</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，北港淮安头附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道北港淮安头附近航段存在浅点。设计水深-1.9（m），最浅点水深-1.1（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry: '111.907173,30.394563',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.2188481, 26.1027507],
        [119.2223815, 26.1029795],
        [119.2222808, 26.1034281],
        [119.2190312, 26.1032816],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于南港湾边附近航段淤浅的通告',
    hdtgNo: '榕水运(2025)05号',
    dateEvent: 1737013740000,
    sshd: '南港湾边附近航段',
    dateStart: 1736985600000,
    dateEnd: 1736985600000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2025</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">01</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">16</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">15</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：04</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，南港湾边附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道南港湾边附近航段存在浅点。设计水深-2.5（m），最浅点水深-0.8（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry: '111.778099,30.415127',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.2711581, 25.9895338],
        [119.2706133, 25.9890922],
        [119.2734881, 25.9864534],
        [119.2741594, 25.9867595],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于南港百七股洲附近航段淤浅的通告',
    hdtgNo: '榕水运(2023)01号',
    dateEvent: 1702339200000,
    sshd: '南港百七股洲附近航段',
    dateStart: 1702371960000,
    dateEnd: 1702371960000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2023</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">12</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">12</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">17</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：06</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，南港百七股洲附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道南港百七股洲附近航段存在浅点。设计水深-2.5（m），最浅点水深-0.9（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry:
      '106.259552,29.30169#106.281569,29.294521#106.292065,29.275577#106.300129,29.264697#106.321378,29.269561#106.339042,29.278393#106.352233,29.284933#106.382185,29.292357#106.383978,29.29927#106.376809,29.316166#106.385514,29.342279#106.396266,29.347143#106.418538,29.355335#106.434411,29.362247#106.435248,29.373391#106.454762,29.390809#106.471215,29.401617#106.492342,29.408068#106.504437,29.407746#106.513791,29.399843#106.522822,29.395328#106.522016,29.401295#106.513146,29.414197#106.497564,29.436414#106.491839,29.443349#106.489581,29.454396#106.49079,29.459154#106.492161,29.472136#106.499741,29.470362#106.501273,29.447784#106.504579,29.442301#106.512885,29.436253#106.513207,29.430608#106.533447,29.402869#106.534173,29.396499#106.533931,29.391258#106.530867,29.387064#106.525061,29.383678#106.51361,29.390854#106.501273,29.39787#106.487323,29.398031#106.479017,29.392951#106.47055,29.386177#106.467083,29.386419#106.460552,29.373276#106.458778,29.363115#106.450633,29.355052#106.44257,29.351746#106.432329,29.350617#106.426362,29.34973#106.423701,29.345295#106.420394,29.345617#106.395639,29.33965#106.392333,29.330296#106.389349,29.321265#106.388946,29.313927#106.390236,29.303847#106.394268,29.289655#106.393462,29.284091#106.388624,29.277963#106.380641,29.274334#106.371367,29.274818#106.354676,29.272399#106.342661,29.268206#106.335807,29.263368#106.324114,29.259417#106.312583,29.257078#106.302745,29.254659#106.291779,29.256272#106.287263,29.261513#106.282183,29.274496#106.271781,29.286269#106.264282,29.291591#106.258234,29.292881#106.259552,29.30169',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.219992, 26.045283],
        [119.221036, 26.039479],
        [119.2239102, 26.0341427],
        [119.224789, 26.034161],
        [119.2217339, 26.0393947],
        [119.220759, 26.0451364],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于北港淮安头附近航段淤浅的通告',
    hdtgNo: '榕水运〔2023〕02号',
    dateEvent: 1720705440000,
    sshd: '北港淮安头附近航段',
    dateStart: 1720706182000,
    dateEnd: 1720792582000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2023</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">12</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">12</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">17</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：06</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，北港淮安头附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道北港淮安头附近航段存在浅点。设计水深-1.9（m），最浅点水深-0.8（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry: '106.498101,29.400859',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.219659, 26.103481],
        [119.219964, 26.10282],
        [119.222712, 26.103736],
        [119.225121, 26.107179],
      ],
    ],
  },
  {
    hdtgName: '福州市水路运输事业发展中心关于南港湾边大桥附近航段淤浅的通告',
    hdtgNo: '榕水运〔2023〕03号',
    dateEvent: 1720695480000,
    sshd: '南港湾边大桥附近航段',
    dateStart: 1720702362000,
    dateEnd: 1720788762000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2023</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">12</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">12</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">17</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：06</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，南港湾边大桥附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道南港湾边大桥附近航段存在浅点。设计水深-2.5（m），最浅点水深-0.9（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry: '106.340487,29.273147',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.237971, 26.016138],
        [119.237344, 26.015475],
        [119.2570929, 26.0032137],
        [119.2579617, 26.0035182],
      ],
    ],
  },
]
/** 公告列表类型  */
export type INoticePointInfoType = (typeof noticePointList)[number]

export const nownoticePointList = [
  {
    hdtgName: '福州市水路运输事业发展中心关于南港百七股洲附近航段淤浅的通告',
    hdtgNo: '榕水运(2025)03号',
    dateEvent: 1737013740000,
    sshd: '南港百七股洲附近航段',
    dateStart: 1736985600000,
    dateEnd: 1743436800000,
    hdtgText:
      "<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">各有关单位、航行船舶：</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">自</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">2025</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">年</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">01</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">月</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">16</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">日</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">15</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">：04</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\"></span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">起，南港百七股洲附近航段</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋;\">#</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">根据最新水深测图，闽江干流航道南港百七股洲附近航段存在浅点。设计水深-2.5（m），最浅点水深-1.4（m）。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">请过往船舶注意避浅，以策安全。</span></p>\n<p style=\"margin: 0cm; margin-bottom: .0001pt; text-indent: 29.25pt; line-height: 30.0pt; mso-line-height-rule: exactly; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman';\">特此通告。</span></p>\n<p class=\"MsoNormal\" style=\"line-height: 28.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 仿宋;\">&nbsp;</span></p>\n<p class=\"MsoNormal\" style=\"text-indent: 32.0pt; mso-char-indent-count: 2.0; line-height: 30.0pt; mso-line-height-rule: exactly; mso-pagination: widow-orphan; background: white;\"><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">联系电话：</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">0591</span><span style=\"font-size: 16.0pt; font-family: 仿宋; mso-ascii-font-family: 'Times New Roman'; mso-hansi-font-family: 'Times New Roman'; mso-bidi-font-family: 'Times New Roman'; mso-font-kerning: 0pt;\">&mdash;</span><span lang=\"EN-US\" style=\"font-size: 16.0pt; font-family: 'Times New Roman','serif'; mso-fareast-font-family: 仿宋; mso-font-kerning: 0pt;\">83323466</span></p>",
    hdtgGeometryType: null,
    hdtgGeometry:
      '105.012598,28.837663#105.005168,28.823511#105.016475,28.819375#105.022096,28.831409#105.012598,28.837663',
    hdtgType: '航段淤浅',
    fbdw: '福州市水路运输事业发展中心',
    coordinates: [
      [
        [119.220896, 26.043121],
        [119.221386, 26.038735],
        [119.225491, 26.032616],
      ],
    ],
  },
]
/** 现存公告列表类型  */
export type nowINoticePointInfoType = (typeof nownoticePointList)[number]

/** 码头信息 */
export const wharfPointList = [
  { name: '长乐通达码头', longitude: 119.450966, latitude: 25.958561 },
  { name: '省闽粮码头', longitude: 119.390117, latitude: 25.937955 },
  { name: '下洋码头', longitude: 119.409584, latitude: 26.00723 },
  { name: '福州枕峰储运公司码头', longitude: 119.390418, latitude: 25.944513 },
  { name: '兴顺码头', longitude: 119.38016, latitude: 26.019983 },
  { name: '晓岐泊船码头', longitude: 119.297, latitude: 26.019983 },
  { name: '烟台山码头', longitude: 119.309643, latitude: 26.044483 },
  { name: '闽江游台江码头', longitude: 119.315079, latitude: 26.050974 },
  { name: '好玩家码头', longitude: 119.215969, latitude: 26.110304 },
  { name: '台江码头', longitude: 119.117246, latitude: 26.132063 },
  { name: '苍霞码头', longitude: 119.309424, latitude: 26.047021 },
  { name: '福州市台江区闽风园-游船码头', longitude: 119.293168, latitude: 26.049023 },
  { name: '水政监察码头', longitude: 119.35656, latitude: 26.045231 },
  { name: '冠城大通游艇码头', longitude: 119.368907, latitude: 26.030349 },
]

/** 码头信息类型  */
export type IWharfPointListType = (typeof wharfPointList)[number]

/** 港口信息 */
export const portPointList = [
  { id: 1, name: '仓山区吴厝渡口', longitude: 119.350199, latitude: 25.979079 },
  { id: 2, name: '马尾旧镇渡口', longitude: 119.44485, latitude: 25.990809 },
  { id: 3, name: '闽江北港', longitude: 119.251606, latitude: 26.076534 },
  { id: 4, name: '金山寺渡口', longitude: 119.231583, latitude: 26.072413 },
  { id: 5, name: '马尾港', longitude: 119.454547, latitude: 25.983062 },
  { id: 6, name: '福州港引航站', longitude: 119.459061, latitude: 25.98241 },
]
/** 港口信息类型  */
export type IPortPointListType = (typeof portPointList)[number]

/** 加油站信息 */
export const gasPointList = [
  { id: 1, name: '荔兴加油站', longitude: 119.450777, latitude: 25.982652 },
  { id: 2, name: '福州市长乐区中化石油加油站(歧头站)', longitude: 119.457197, latitude: 25.959044 },
  {
    id: 3,
    name: '福州市仓山区中国海油加油站(南江滨站)',
    longitude: 119.386573,
    latitude: 26.011826,
  },
  {
    id: 4,
    name: '福州市仓山区中国石化加油站(福州城门南站)',
    longitude: 119.35294,
    latitude: 26.015411,
  },
  {
    id: 5,
    name: '福州市仓山区中石化森美(福州城门北加油站)',
    longitude: 119.29272,
    latitude: 25.989818,
  },
  { id: 6, name: '福州市仓山区中国石化加油站(湾边站)', longitude: 119.257223, latitude: 26.015296 },
  { id: 7, name: '福州市仓山区中石化森美(洪塘加油站)', longitude: 119.234269, latitude: 26.065599 },
  {
    id: 8,
    name: '福州市闽侯县中石化森美加油站(文山里站)',
    longitude: 119.246859,
    latitude: 26.098698,
  },
  {
    id: 9,
    name: '福州市闽侯县中石化森美加油站(竹岐站)',
    longitude: 119.104607,
    latitude: 26.145828,
  },
  {
    id: 10,
    name: '福州市闽侯县石化服务区加油站(长坪园站)',
    longitude: 119.082343,
    latitude: 26.1851,
  },
  {
    id: 11,
    name: '福州市闽侯县中国石化加油站(福兰线站)',
    longitude: 118.983974,
    latitude: 26.188048,
  },
  {
    id: 12,
    name: '福州市闽清县中石化森美加油站(建兴站)',
    longitude: 118.909847,
    latitude: 26.203138,
  },
  {
    id: 13,
    name: '福州市闽清县中石化森美加油站(闽清溪口站)',
    longitude: 118.883946,
    latitude: 26.20648,
  },
  { id: 14, name: '速加石化加油站', longitude: 118.875675, latitude: 26.226091 },
  { id: 15, name: '中石化森美(闽清榕星加油站)', longitude: 118.872395, latitude: 26.23275 },
]
/** 加油站信息类型  */
export type IGasPointListType = (typeof gasPointList)[number]

/** 水位站数据 */
export const gaugingStationList = [
  { id: 1, name: '福州分局水位站', longitude: 119.2355, latitude: 26.10644 },
  { id: 2, name: '竹歧水位站', longitude: 119.120546, latitude: 26.148169 },
]
export type IWaterLevelType = (typeof gaugingStationList)[number]
/** 救援站数据 */
export const rescueStationList = [
  { name: '水口海事搜救站', longitude: 118.8503, latitude: 26.295316 },
  { name: '永丰海事搜救站', longitude: 119.23396, latitude: 26.110055 },
  { name: '湾边海事搜救站', longitude: 119.264558, latitude: 26.000659 },
]

export type IWaterPointListType = (typeof waterStationList)[number]
/**水位点位数据 */
export const waterStationList = [
  {
    swzid: 'YB_ff808081646e7d4401646ea2aac80000',
    swzmc: '宜宾（合江门）',
    hdly: '1',
    lcwz: 1044,
    clsw: 2.15,
    cid: null,
    cname: null,
    ctime: null,
    lat: 28.7723,
    lon: 104.634,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.04',
    szSwjz: '',
    szSdjz: '1',
    scsw: 259.42,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'YB_ff808081646e7d4401646eaedfe50003',
    swzmc: '江安（白沙湾）',
    hdly: '1',
    lcwz: 974,
    clsw: 1.88,
    cid: null,
    cname: null,
    ctime: null,
    lat: 28.726,
    lon: 105.089,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.03',
    szSwjz: '',
    szSdjz: '1',
    scsw: 241.85,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'LZ_402881e5638afaa201638b158ef80003',
    swzmc: '泸州（麻沙桥）',
    hdly: '1',
    lcwz: 911,
    clsw: 2.22,
    cid: null,
    cname: null,
    ctime: null,
    lat: 28.9123,
    lon: 105.457,
    delflag: 0,
    swtime: '2025-04-11 12:00:00',
    sqzlx: '2',
    swbf: '-0.06',
    szSwjz: '',
    szSdjz: '1',
    scsw: 225.15,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'LZ_402881e5638afaa201638b22b4b8000b',
    swzmc: '朱沱（汉东村）',
    hdly: '1',
    lcwz: 806,
    clsw: 1.94,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.0158,
    lon: 105.849,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.06',
    szSwjz: '',
    szSdjz: '1',
    scsw: 196.94,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'CQ_ff808081684a58b2016924b704490002',
    swzmc: '江津（猪圈门）',
    hdly: '1',
    lcwz: 723.4,
    clsw: 1.86,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.2571,
    lon: 106.299,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '0',
    szSwjz: '',
    szSdjz: '1',
    scsw: 178.04,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'CQ_ff808081684a58b2016927aa45050014',
    swzmc: '重庆（寸滩）',
    hdly: '1',
    lcwz: 653.2,
    clsw: 3.07,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.62,
    lon: 106.595,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.02',
    szSwjz: '',
    szSdjz: '1',
    scsw: 160.4,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'CQ_ff808081684a58b20169288cb82f0032',
    swzmc: '长寿（小石溪）',
    hdly: '1',
    lcwz: 583.45,
    clsw: 159.37,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.8228,
    lon: 107.066,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '0',
    szSwjz: '',
    szSdjz: '1',
    scsw: 157.77,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'CQ_ff808081684a58b2016927eced22002a',
    swzmc: '涪陵（白鹤梁）',
    hdly: '1',
    lcwz: 537.4,
    clsw: 159.28,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.7167,
    lon: 107.381,
    delflag: 0,
    swtime: '2025-04-11 13:00:00',
    sqzlx: '2',
    swbf: '+0.01',
    szSwjz: '',
    szSdjz: '1',
    scsw: 157.68,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'CQ_ff808081684a58b20169279396f9000a',
    swzmc: '万州（红花地）',
    hdly: '1',
    lcwz: 332.9,
    clsw: 159.32,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.8009,
    lon: 108.386,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '0',
    szSwjz: '',
    szSdjz: '1',
    scsw: 157.6,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'YC_0000000068fa1b800168fcfc547c0002',
    swzmc: '秭归(郭家坝)',
    hdly: '1',
    lcwz: 77.8,
    clsw: 159.19,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.9569,
    lon: 110.748,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.07',
    szSwjz: '3',
    szSdjz: '',
    scsw: 157.47,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'YC_40280d8168f1344f0168f14cb08c0000',
    swzmc: '宜昌(中水门)',
    hdly: '1',
    lcwz: 3,
    clsw: 1.75,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.6899,
    lon: 111.27,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.08',
    szSwjz: '',
    szSdjz: '1',
    scsw: 39.05,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'YC_0000000068fa1b800168fd15bab90017',
    swzmc: '车阳河(关洲)',
    hdly: '2',
    lcwz: 563,
    clsw: 1.07,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.2559,
    lon: 111.572,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.05',
    szSwjz: '',
    szSdjz: '1',
    scsw: 36.19,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'YC_0000000068fa1b800168fd0d1f66000d',
    swzmc: '枝江(李家渡)',
    hdly: '2',
    lcwz: 540,
    clsw: 0.8,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.4009,
    lon: 111.723,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.01',
    szSwjz: '',
    szSdjz: '1',
    scsw: 33.31,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_941dfd3febf14483bdac0f07e451d420',
    swzmc: '沙市（杨林矶）',
    hdly: '2',
    lcwz: 482.8,
    clsw: -1.06,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.3209,
    lon: 112.204,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.02',
    szSwjz: '',
    szSdjz: '1',
    scsw: 29.44,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_713b188c519d44eda2643b9aaec2f04b',
    swzmc: '郝穴（航道码头）',
    hdly: '2',
    lcwz: 427,
    clsw: -0.26,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.0299,
    lon: 112.404,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.01',
    szSwjz: '',
    szSdjz: '1',
    scsw: 27.14,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_4fb538bd92f9401292665a8bbd61f1f8',
    swzmc: '石首（航道码头）',
    hdly: '2',
    lcwz: 387,
    clsw: 1.18,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.7384,
    lon: 112.406,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '0',
    szSwjz: '',
    szSdjz: '1',
    scsw: 25.7,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_b0b56f22f61147a1b0e3f9bca717ef99',
    swzmc: '监利（泳协码头）',
    hdly: '2',
    lcwz: 313,
    clsw: 2.74,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.8082,
    lon: 112.897,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.02',
    szSwjz: '',
    szSdjz: '1',
    scsw: 23.14,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_5c278a0f3d9d41bb8d7e5bdf9634890d',
    swzmc: '城陵矶（岳阳关）',
    hdly: '2',
    lcwz: 230,
    clsw: 3.53,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.4387,
    lon: 113.143,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.02',
    szSwjz: '',
    szSdjz: '1',
    scsw: 18.94,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_55ead3582d34421a9a9f87594a7ab21b',
    swzmc: '莫家河（嘉鱼大桥）',
    hdly: '2',
    lcwz: 121.6,
    clsw: 2.61,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.052,
    lon: 113.954,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.03',
    szSwjz: '',
    szSdjz: '1',
    scsw: 14.82,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_b8a7e37f0781445ab204a47ed8bf1f40',
    swzmc: '汉口（武汉关）',
    hdly: '3',
    lcwz: 1042.7,
    clsw: 1.98,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.5784,
    lon: 114.292,
    delflag: 0,
    swtime: '2025-04-11 13:00:00',
    sqzlx: '2',
    swbf: '0',
    szSwjz: '',
    szSdjz: '1',
    scsw: 11.88,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'WH_1c713fb0747541a6b62b97a48bde32c5',
    swzmc: '黄石（黄石大桥）',
    hdly: '3',
    lcwz: 913.6,
    clsw: 1.8,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.2414,
    lon: 115.067,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '0',
    szSwjz: '',
    szSdjz: '1',
    scsw: 9,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_402881e84f2b243a014f2b26a569000f',
    swzmc: '九江（航道码头）',
    hdly: '3',
    lcwz: 794,
    clsw: 1.6,
    cid: null,
    cname: null,
    ctime: null,
    lat: 29.7251,
    lon: 115.969,
    delflag: 0,
    swtime: '2025-04-11 13:00:00',
    sqzlx: '2',
    swbf: '+0.01',
    szSwjz: '',
    szSdjz: '1',
    scsw: 6.67,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_2c92402178241b7901783e2b4efa0471',
    swzmc: '安庆（马窝）',
    hdly: '3',
    lcwz: 632,
    clsw: 1.65,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.521,
    lon: 117.142,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.02',
    szSwjz: '',
    szSdjz: '1',
    scsw: 3.85,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_402881e84f2b243a014f2b2b26fa0042',
    swzmc: '铜陵（外贸码头）',
    hdly: '3',
    lcwz: 547,
    clsw: 1.74,
    cid: null,
    cname: null,
    ctime: null,
    lat: 30.8755,
    lon: 117.737,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.24',
    szSwjz: '',
    szSdjz: '1',
    scsw: 2.92,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_2c9240fe77bd03210178108cf42a72e9',
    swzmc: '芜湖（芜湖大桥）',
    hdly: '3',
    lcwz: 439,
    clsw: 1.62,
    cid: null,
    cname: null,
    ctime: null,
    lat: 31.3721,
    lon: 118.333,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.07',
    szSwjz: '',
    szSdjz: '2',
    scsw: 2.15,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_402881e84f2b243a014f2b2e4812006c',
    swzmc: '南京（下关）',
    hdly: '3',
    lcwz: 347,
    clsw: 1.28,
    cid: null,
    cname: null,
    ctime: null,
    lat: 32.0919,
    lon: 118.728,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.12',
    szSwjz: '',
    szSdjz: '2',
    scsw: 1.3,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_2c9240214f50ba3a0150655a06be000c',
    swzmc: '镇江(定易洲)',
    hdly: '3',
    lcwz: 274,
    clsw: 0.93,
    cid: null,
    cname: null,
    ctime: null,
    lat: 32.2438,
    lon: 119.41,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '-0.14',
    szSwjz: '',
    szSdjz: '2',
    scsw: 0.7,
    ipush: 0,
    focus_type: null,
  },
  {
    swzid: 'NJ_2c9240215e2e3ada015e75244fd22c63',
    swzmc: '丹华港',
    hdly: '3',
    lcwz: 133,
    clsw: 2.72,
    cid: null,
    cname: null,
    ctime: null,
    lat: 32.0629,
    lon: 120.444,
    delflag: 0,
    swtime: '2025-04-11 14:00:00',
    sqzlx: '2',
    swbf: '+0.77',
    szSwjz: '',
    szSdjz: '2',
    scsw: 1.76,
    ipush: 0,
    focus_type: null,
  },
]
